import { render, staticRenderFns } from "./customClick.vue?vue&type=template&id=3a8cc9f4&scoped=true"
import script from "./customClick.vue?vue&type=script&lang=js"
export * from "./customClick.vue?vue&type=script&lang=js"
import style0 from "./customClick.vue?vue&type=style&index=0&id=3a8cc9f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8cc9f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a8cc9f4')) {
      api.createRecord('3a8cc9f4', component.options)
    } else {
      api.reload('3a8cc9f4', component.options)
    }
    module.hot.accept("./customClick.vue?vue&type=template&id=3a8cc9f4&scoped=true", function () {
      api.rerender('3a8cc9f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/customManage/customClick.vue"
export default component.exports